export default function TestimonialSection() {
  return (
    <section className="bg-background-50 py-14 md:py-20">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-8 md:gap-12 items-center">
          <div className="lg:w-[40%] w-full">
            <div className="aspect-[3/4] rounded-lg overflow-hidden bg-accent-100/80">
              <img
                src="https://readdy.ai/api/search-image?query=Diverse%20professional%20editorial%20team%20of%20three%20people%20standing%20together%20in%20a%20bright%20modern%20office%20space%20with%20exposed%20brick%20wall%20and%20potted%20plants%20warm%20natural%20lighting%20genuine%20smiles%20approachable%20atmosphere%20documentary%20style%20photography%20natural%20poses&width=800&height=1067&seq=editorial-team-v3&orientation=portrait&nocache=true"
                alt="OOPBUY Redaktionsteam"
                title="OOPBUY Spreadsheet Redaktionsteam"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          <div className="lg:w-[60%] w-full">
            <p className="text-xs md:text-sm text-foreground-500 uppercase tracking-wider mb-3 font-label">
              Content Quality Standards
            </p>
            <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 mb-2 leading-tight">
              Editorial Review
            </h2>
            <h3 className="font-heading text-3xl md:text-5xl font-bold text-foreground-300 mb-6 leading-tight">
              Process
            </h3>
            <blockquote className="text-foreground-700 text-base md:text-lg leading-relaxed mb-6 border-l-2 border-accent-500 pl-5">
              Jeder Inhalt auf oopbuyspread.rest durchläuft einen strengen mehrstufigen 
              Qualitätsprozess. Unser Team aus deutschen Muttersprachlern, SEO-Experten und 
              Fachprüfern stellt sicher, dass alle Informationen korrekt, aktuell und für 
              deutsche Nutzer relevant sind. Die Fakten werden unabhängig verifiziert, 
              Quellen transparent dokumentiert und Inhalte regelmäßig aktualisiert.
            </blockquote>
            <p className="text-foreground-900 font-semibold text-sm">
              — Senior Editor & Fact Checker
            </p>
            <div className="flex items-center gap-3 mt-6">
              <button className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-200 text-foreground-500 hover:border-foreground-400 hover:text-foreground-700 transition-colors cursor-pointer" aria-label="Zurück">
                <i className="ri-arrow-left-line"></i>
              </button>
              <button className="w-10 h-10 flex items-center justify-center rounded-full bg-foreground-950 text-background-50 hover:bg-foreground-800 transition-colors cursor-pointer" aria-label="Weiter">
                <i className="ri-arrow-right-line"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}